import { render, staticRenderFns } from "./CredentialRenderer.vue?vue&type=template&id=3a4d1746&scoped=true&"
import script from "./CredentialRenderer.vue?vue&type=script&lang=js&"
export * from "./CredentialRenderer.vue?vue&type=script&lang=js&"
import style0 from "./CredentialRenderer.vue?vue&type=style&index=0&id=3a4d1746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d1746",
  null
  
)

export default component.exports